
// Directives
require('./components/breadcrumb/breadcrumb-component');
require('./components/topnav/topnav-component');
require('./components/sidenav/sidenav-component');

// Factories
require('./factories/nav-service');


// WEBPACK FOOTER //
// ./src/app/components/navigation/navigation-components.js